// extracted by mini-css-extract-plugin
export var legendIndicator = "_bx-1";
export var legendRight = "_bx-0";